export default "__VITE_ASSET__CnZ1Ug2U__"